import React from 'react'
import PageWrapper from "Pages/@PageWrapper"
import { ADMIN_ROUTES } from "@constants"


export default function AdminDataStudioSingle() {

	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={ADMIN_ROUTES.DATA_STUDIO_SINGLE_SUBTITLE}
		isEmpty={false}
	>
		<iframe
			src="https://datastudio.google.com/embed/reporting/1uOD6DmyKymZG6VfuTj5Pr7pcjRKL0pZs/page/9G6S"
			style={{
				border: 0,
				width: '100%',
				height: '100vh'
			}}
			allowFullScreen=""/>
	</PageWrapper>
}